var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.render)?_c('portal',{attrs:{"selector":"#custom-attributes-management"}},[_c('div',{staticClass:"v-application",staticStyle:{"display":"block"}},[_c('ConfirmationDialogProvider',[_c('Header2',[_vm._v("Eigene Felder bearbeiten")]),_vm._v(" "),_c('CustomAttributesManagement')],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }